<template>
  <v-radio
    :label="item.label"
    :value="index"
    :disabled="disabled || item.readonly"
    @change="onChange"
  ></v-radio>
<!--   <v-switch
    class="ml-2 mt-0"
    inset
    dense
    hide-details="auto"
    v-model="item.value"
    :label="item.label"
    :disabled="disabled || item.readonly"
    @change="onChange"
  >
  </v-switch> -->
</template>

<script>
  export default {
    name: 'p-switch',
    props: {
      item: Object,
      disabled: { type: Boolean, default: false },
      index: Number
    },
    data: () => ({
    }),
    mounted() {
      if (this.index === 0) {
        this.onChange() // imposta il default
      }
    },
    methods: {
      onChange() {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: this.index, index: this.index })
      }
    }
  }
</script>